import EqualHeightElementCollection from "parent/src/js/base/Controllers/EqualHeightElementCollection";

class PostCards extends EqualHeightElementCollection {
	getSelector() {
		return ".post-card.equal-height";
	}

	getComponents() {
		const selector = this.getSelector();
		return [
			document.querySelectorAll(selector +" .post-thumbnail"),
			document.querySelectorAll(selector +" .read-more-zone"),
			document.querySelectorAll(selector +" .post-header"),
			document.querySelectorAll(selector +" .post-excerpt")
		];
	}
}

export default PostCards;
